<div class="modal-header">
    <h5 class="modal-title">
        {{ isEditMode ? 'Editar Usuário' : 'Novo Usuário' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <app-input
                    formControlName="firstName"
                    label="Nome"
                    placeholder="Digite o nome"
                    [required]="true"/>
            </div>
            <div class="col-md-6">
                <app-input
                    formControlName="lastName"
                    label="Sobrenome"
                    placeholder="Digite o sobrenome"
                    [required]="true"/>
            </div>
        </div>

        <app-input
            formControlName="email"
            label="E-mail"
            type="email"
            placeholder="usuario@fisconly.com"
            [required]="true"/>

        @if (!isEditMode) {
            <app-input
                formControlName="password"
                label="Senha"
                type="password"
                placeholder="Mínimo 6 caracteres"
                [required]="true"/>
        }

        <app-select
            formControlName="profile"
            label="Perfil"
            [items]="profileOptions"
            bindLabel="label"
            bindValue="value"
            placeholder="Selecione o perfil"
            [required]="true"/>

        @if (isEditMode) {
            <app-switch
                formControlName="status"
                label="Usuário Ativo"
                description="Usuários inativos não podem fazer login"
                containerStyles="mb-0"/>
        }
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
            Cancelar
        </button>
        <button type="submit" class="btn btn-dark">
           Salvar Registro
        </button>
    </div>
</form>

